export class RequestFeedback {
  requestId: number;
  requestNumber: string;
  requestTypeName: string;
  answer: string;
  remarks: string;
  feedbackById: number;
  feedbackByName: string;
  feedbackDate: Date;
}




// WEBPACK FOOTER //
// ./src/app/core/models/request-feedback.ts